import { ToolbarButton } from './toolbar-button.js';
import { ToolbarDropdownIndicator } from './toolbar-dropdown-indicator.js';
import { ToolbarIcon } from './toolbar-icon.js';
import { ToolbarRoot } from './toolbar-root.js';
import { ToolbarSeparator } from './toolbar-separator.js';
import { ToolbarToggleGroup } from './toolbar-toggle-group.js';
import { ToolbarToggleItem } from './toolbar-toggle-item.js';
import { ToolbarTriggerButton } from './toolbar-trigger-button.js';
import { ToolbarTextToggleItem } from './toolbar-text-toggle-item.js';
/**
 * A container for grouping a set of controls, such as buttons, toggle groups or dropdowns.
 * @example
 *   <Toolbar.Root>
 *       <Toolbar.ToggleGroup type="single">
 *           <Toolbar.ToggleItem aria-label="draw" icon={Pencil} value="pencil" />
 *           <Toolbar.ToggleItem aria-label="stop-drawing" icon={PencilCrossed} value="pencilCrossed" />
 *       </Toolbar.ToggleGroup>
 *       <Toolbar.Separator />
 *
 *       <Toolbar.Button>
 *           share
 *       </Toolbar.Button>
 *       <Toolbar.Separator />
 *
 *       <Toolbar.Button>
 *           Upload <Toolbar.DropdownIndicator direction="down" />
 *       </Toolbar.Button>
 *   </Toolbar.Root>
 */

var Toolbar = {
  /**
   * Contains all parts of the toolbar component.
   */
  Root: ToolbarRoot,

  /**
   * Two-state button that can be toggled on or off.
   */
  ToggleItem: ToolbarToggleItem,

  /**
   * Two-state text button that can be toggled on or off.
   */
  TextToggleItem: ToolbarTextToggleItem,

  /**
   * Parent for a set of `Toolbar.ToggleItem` subcomponents.
   */
  ToggleGroup: ToolbarToggleGroup,

  /**
   * A button that is used as a trigger for dropdown elements.
   */
  DropdownTriggerButton: ToolbarTriggerButton,

  /**
   * SVG element used to render icon in buttons.
   */
  Icon: ToolbarIcon,

  /**
   * A button item.
   */
  Button: ToolbarButton,

  /**
   * Component used to visually separate options in the Toolbar.
   */
  Separator: ToolbarSeparator,

  /**
   * Caret icon indicating dropdown.
   */
  DropdownIndicator: ToolbarDropdownIndicator
};
export { Toolbar };